import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { makeSelectIsAuthenticated } from 'reducers/auth/selectors';
import { FeatureFlagsContext } from 'hooks/useFeatureFlags';

function NotLoggedInRoute({ isAuthenticated, component: ChildComponent, location, ...rest }) {
  const featureFlags = {
    signupV2: localStorage.getItem('signup-v2') === 'true',
  };

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            <Redirect to={{ pathname: '/dashboard', state: { from: location } }} />
          ) : (
            <ChildComponent {...props} />
          )
        }
      />
    </FeatureFlagsContext.Provider>
  );
}

NotLoggedInRoute.propTypes = {
  location: PropTypes.object,
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
});

export default connect(mapStateToProps)(NotLoggedInRoute);
